module.exports = __webpack_public_path__ + "assets/img/store-banner-03.f2a2e3a8.png";